// Format a single RPC value as "$X.XX", or `fallback` when null/undefined.
export function formatRpc(value, fallback = '') {
  if (value == null) {
    return fallback
  }

  return `$${Number(value).toFixed(2)}`
}

// Format an RPC range as "$min – $max", using "0" for an unbounded min and
// "∞" for an unbounded max.
export function formatRpcRange(min, max) {
  return `${formatRpc(min, '0')} – ${formatRpc(max, '∞')}`
}

// Half-open range overlap check matching the server-side rule in
// CategoryTierGroupCRUDService._RangesOverlap. Ranges [aMin, aMax) and
// [bMin, bMax) overlap when max(aMin, bMin) < min(aMax, bMax).
// null min = -infinity, null max = +infinity.
export function rangesOverlap(aMin, aMax, bMin, bMax) {
  const lower = aMin == null && bMin == null
    ? Number.NEGATIVE_INFINITY
    : aMin == null ? Number(bMin)
      : bMin == null ? Number(aMin)
        : Math.max(Number(aMin), Number(bMin))

  const upper = aMax == null && bMax == null
    ? Number.POSITIVE_INFINITY
    : aMax == null ? Number(bMax)
      : bMax == null ? Number(aMax)
        : Math.min(Number(aMax), Number(bMax))

  return lower < upper
}
